import type { MetricTone } from '@lognai/synapse-design-system-v2';
import { Boxes, Radar } from '@lognai/synapse-design-system-v2/icons';
import { WORKSPACE_KPI_REGISTRY } from './workspace-kpis';

export const workspaceToneClasses: Record<MetricTone, string> = {
  primary: 'bg-primary-subtle text-primary',
  info: 'bg-info-subtle text-info-foreground',
  warning: 'bg-warning-subtle text-warning-foreground',
  success: 'bg-success-subtle text-success-foreground',
  destructive: 'bg-destructive-subtle text-destructive-foreground',
  neutral: 'bg-muted text-muted-foreground',
};

export function workspaceModuleStyle(module: string) {
  if (module === 'Operations') return { icon: Radar, tone: 'info' as const };
  const match = WORKSPACE_KPI_REGISTRY.find(
    (item) => item.module === (module === 'Collaboration' ? 'Tasks' : module)
  );
  return { icon: match?.icon ?? Boxes, tone: match?.tone ?? 'neutral' };
}
